import { chat } from '../types';

const INITIAL_STATE = {
    error: undefined,
    chats: [],
    chatsDropdown: [],
    chatMessages: {},
    chatDetails: {},
    chatUsers: [],
    chatLiveData: {},
    openedChatBoxData: [],
    chatMedia: {},
    searchedMessages: [],
    chatLogsData: {},
    chatMembers: [],
    usersForMentions: []
};


const chatReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case chat.GET_CHATS_SUCCESS: {
            const { page, data, metaData } = action.payload;
            return {
                ...state,
                chats: page === 1 ? data : [...state.chats, ...data],
                metaData
            };
        }

        case chat.CLOSE_CHAT_SUCCESS: {
            const { id } = action.payload;
            return {
                ...state,
                chats: state.chats.filter(chat => chat.id !== id)
            };
        }

        case chat.GET_CHATS_DROPDOWN_SUCCESS: {
            const { data } = action.payload;
            let chatsDropdown = [...(state.chatsDropdown || []), ...data];
            chatsDropdown = Array.from(new Map(chatsDropdown.map(item => [item.id, item])).values());
            return {
                ...state,
                chatsDropdown
            };
        }
        case chat.GET_CHAT_BY_ID_SUCCESS: {
            const { data, updateListAtFirst } = action.payload;
            let chats = state.chats;
            if (updateListAtFirst) {
                chats = [data, ...chats]
            }
            return {
                ...state,
                chatDetails: {
                    ...state.chatDetails,
                    [data.id]: data
                },
                chats
            }
        }
        case chat.GET_CHAT_MESSAGES_SUCCESS: {
            const { data, id, isSearch, reset, direction, metaData, target_message_id, cursor } = action.payload;

            if (isSearch) {
                return {
                    ...state,
                    searchedMessages: isSearch
                        ? { ...state.searchedMessages, [id]: data }
                        : state.searchedMessages,
                    metaData
                }
            }

            let list = state.chatMessages[id] || [];
            if (reset) list = [];

            if (direction === 'up') {
                if (data.length === 0 && list.length > 0) {
                    list = [...list];
                    list[0] = { ...list[0], isLast: true };
                } else {
                    list = [...data, ...list];
                }
            } else if (direction === 'down') {
                if (data.length === 0 && list.length > 0) {
                    list = [...list];
                    list[list.length - 1] = { ...list[list.length - 1], isLast: true };
                } else {
                    list = [...list, ...data];
                }
            } else {
                list = [...data];
                if (data.length === 0) {
                    list = [];
                }
            }

            if (!cursor && !direction && !target_message_id && list.length > 0) {
                list[list.length - 1] = { ...list[list.length - 1], isLast: true };
            }

            const uniqueList = [...new Map(list.map(item => [item.id, item])).values()];
            return {
                ...state,
                chatMessages: {
                    ...state.chatMessages,
                    [id]: uniqueList
                }
            }
        }

        case chat.CLEAR_CHAT_MESSAGES: {
            const { id } = action.payload;
            return {
                ...state,
                chatMessages: { ...state.chatMessages, [id]: [] }
            }
        }

        case chat.GET_CHAT_USERS_SUCCESS: {
            const { data, page } = action.payload;
            if (page > 1 && data?.length > 0) {
                return {
                    ...state,
                    chatUsers: [...state.chatUsers, ...data]
                }
            }
            return {
                ...state,
                chatUsers: data
            }
        }
        case chat.GET_MEMBER_IN_CHAT_SUCCESS: {
            const { data, id } = action.payload;
            return {
                ...state,
                chatDetails: {
                    ...state.chatDetails,
                    [id]: {
                        ...state.chatDetails[id],
                        members: data
                    }
                }
            }
        }
        case chat.LIVE_MESSAGE_DATA: {
            const { data, loginUserId } = action.payload;
            const chats = state.chats.map(chat => {
                if (chat.id === data.chat_id) {
                    let c = {
                        ...chat,
                        last_message: data,
                        last_message_id: data.id
                    };
                    if (data && loginUserId === data.author_id) {
                        c["unread_count"] = parseInt(c.unread_count || 0) + 1
                    }
                    return c;
                }
                return chat;
            });

            const existingMessages = state.chatMessages[data.chat_id] || [];
            const messagesWithoutIsLast = existingMessages.map(message => {
                const { isLast, ...messageWithoutIsLast } = message;
                return messageWithoutIsLast;
            });

            const updatedMessages = [...messagesWithoutIsLast, { ...data, isLast: true }];

            const dedupedMessages = [
                ...new Map(updatedMessages.map(item => [item.id, item])).values()
            ];

            const chatMessages = {
                ...state.chatMessages,
                [data.chat_id]: dedupedMessages
            };

            const existingMedia = state.chatMedia[data.chat_id] || [];
            const updatedMedia = data.media.length > 0
                ? [...existingMedia, ...data.media]
                : existingMedia;

            const chatMedia = {
                ...state.chatMedia,
                [data.chat_id]: updatedMedia
            };

            return {
                ...state,
                chats,
                chatMessages,
                chatMedia
            };
        }

        case chat.DELETE_LIVE_MESSAGE_DATA: {
            const { message_id, chat_id } = action.payload;
            const chatMessages = { ...state.chatMessages };
            chatMessages[chat_id] = chatMessages[chat_id].filter(message => message.id !== message_id);
            return {
                ...state,
                chatMessages
            }
        }

        case chat.EDIT_LIVE_MESSAGE_DATA: {
            const { message_id, chat_id, content, is_edited = false } = action.payload;
            const chatMessages = { ...state.chatMessages };
            chatMessages[chat_id] = chatMessages[chat_id].map(message => message.id === message_id ? { ...message, content, is_edited } : message);
            return {
                ...state,
                chatMessages
            }
        }

        case chat.EDIT_LIVE_MESSAGE_DATA: {
            const data = action.payload;
            const chatMessages = state.chatMessages;
            chatMessages[data.chat_id] = chatMessages[data.chat_id].map(message => message.id === data.id ? data : message);
            return {
                ...state,
                chatMessages
            }
        }

        case chat.MEMBERS_ADDED_OR_DELETE: {
            const { event, data, chat_id, loginUserId, navigate = () => { } } = action.payload;

            if (event.endsWith('added') && data.members) {
                return {
                    ...state,
                    chatDetails: {
                        ...state.chatDetails,
                        [chat_id]: {
                            ...state.chatDetails[chat_id],
                            members: [...state.chatDetails[chat_id].members, ...data.members]
                        }
                    }
                }
            }

            if (event.endsWith('removed') && data.members) {
                const memberIds = data.members.map(member => member.id);
                let chats = state.chats;
                const isLoginUserRemoved = memberIds.includes(loginUserId);
                if (isLoginUserRemoved) {
                    chats = chats.filter(chat => chat.id !== chat_id);
                    navigate('/chats');
                }
                return {
                    ...state,
                    chatDetails: {
                        ...state.chatDetails,
                        [chat_id]: {
                            ...state.chatDetails[chat_id],
                            members: state.chatDetails[chat_id].members.filter(member => !memberIds.includes(member.id))
                        }
                    },
                    chats
                }
            }

            return state
        }

        case chat.REMOVE_TEAMS_FROM_CHAT_SUCCESS: {
            const { id, teamIds } = action.payload;
            return {
                ...state,
                chatDetails: {
                    ...state.chatDetails,
                    [id]: {
                        ...state.chatDetails[id],
                        teams: state.chatDetails[id].teams.filter(team => !teamIds.includes(team.id))
                    }
                }
            }
        }


        case chat.OPEN_CHAT_MODAL_SUCCESS: {
            const data = action.payload;
            return {
                ...state,
                openedChatBoxData: [...state.openedChatBoxData, data]
            }
        }

        case chat.TAKE_CHAT_AT_FIRST_POSITION: {
            const chat = { ...action.payload, openInBackground: false };
            const updatedOpenedChatBoxData = state.openedChatBoxData.filter(({ chatId }) => chatId !== chat.chatId)
            return {
                ...state,
                openedChatBoxData: [...updatedOpenedChatBoxData, chat]
            }
        }

        case chat.CLOSE_CHAT_MODAL_SUCCESS: {
            const ids = action.payload;
            const updatedOpenedChatBoxData = state.openedChatBoxData.filter(({ chatId }) => !ids.includes(chatId))
            return {
                ...state,
                openedChatBoxData: updatedOpenedChatBoxData
            }
        }
        case chat.GET_CHAT_MEDIA_SUCCESS: {
            const { data, id, page, type = 'ALL' } = action.payload;
            const existingMedia = state.chatMedia[id] || [];
            const uniqueList = [...new Map([...data, ...existingMedia].map(item => [item.id, item])).values()];
            return {
                ...state,
                chatMedia: {
                    ...state.chatMedia,
                    [`${id}-${type}`]: page === 1 ? uniqueList : [...existingMedia, ...uniqueList]
                }
            }
        }
        case chat.CUSTOMER_MEDIA_SUCCESS: {
            const { data } = action.payload;
            return {
                ...state,
                customerSignoffMedia: data
            }
        }
        case chat.EDIT_CHAT_MESSAGE_SUCCESS: {
            const { data, id } = action.payload;
            const chatMessages = { ...state.chatMessages };

            if (chatMessages[id]) {
                chatMessages[id] = chatMessages[id].map((message) => {
                    if (message.id === data.id) {
                        return {
                            ...message,
                            ...data,
                            isEditLoading: false
                        }
                    }
                    return message;
                })
            }

            return {
                ...state,
                chatMessages
            }
        }
        case chat.DELETE_CHAT_MESSAGE_SUCCESS: {
            const { data, id } = action.payload;
            let chatMessages = { ...state.chatMessages };
            if (chatMessages[id]) {
                chatMessages[id] = chatMessages[id].filter((message) => message.id !== data.id);
            }
            return {
                ...state,
                chatMessages
            }
        }
        case chat.NEW_MESSAGE_CHAT_ID: {
            const { data, isSenderIsLoginUser = false } = action.payload;
            const chatWithNewMessage = state.chats.find(chat => chat.id === data.chatId);
            if (!chatWithNewMessage) {
                return state;
            }

            const updatedChat = {
                ...chatWithNewMessage,
            };

            if (!isSenderIsLoginUser) {
                updatedChat.unread_count = data.uCount
            }

            const updatedChats = [
                updatedChat,
                ...state.chats.filter(chat => chat.id !== data.chatId)
            ];

            return {
                ...state,
                chats: updatedChats,
            }
        };

        case chat.UPDATE_CHAT_BY_ID_SUCCESS: {
            const { data } = action.payload;
            const chats = state.chats.map((chat) => {
                if (chat.id === data.id) {
                    return {
                        ...chat,
                        title: data.title,
                        description: data.description,
                        icon: data.icon
                    }
                }
                return chat;
            })
            return {
                ...state,
                chatDetails: {
                    ...state.chatDetails, [data.id]: {
                        ...state.chatDetails[data.id],
                        title: data.title,
                        description: data.description,
                        icon: data.icon
                    }
                },
                chats
            }
        }

        case chat.EDITING_MESSAGE: {
            const { messageId, id } = action.payload;
            const chatMessages = { ...state.chatMessages };
            if (chatMessages[id]) {
                chatMessages[id] = chatMessages[id].map((message) => {
                    if (message.id === messageId) {
                        message.isEditLoading = true;
                    }
                    return message;
                });
            }
            return {
                ...state,
                chatMessages
            }
        }
        case chat.GET_CHAT_LOGS_SUCCESS: {
            const { data, id } = action.payload;
            return {
                ...state,
                chatLogsData: {
                    ...state.chatLogsData,
                    [id]: data
                }
            }
        }
        case chat.READ_MESSAGE_SUCCESS: {
            const { id } = action.payload;
            return {
                ...state,
                chatDetails: {
                    ...state.chatDetails,
                    [id]: {
                        ...state.chatDetails[id],
                        unread_count: 0
                    }
                },
                chats: state.chats.map(chat => {
                    if (chat.id === id) {
                        return {
                            ...chat,
                            unread_count: 0
                        }
                    }
                    return chat;
                })
            }
        };

        case chat.CHAT_NOTIFICATION_SUCCESS: {
            const { id, mode } = action.payload;
            return {
                ...state,
                chatDetails: { ...state.chatDetails, [id]: { ...state.chatDetails[id], notification_mode: mode } }
            }
        }

        case chat.UPDATE_MEDIA_STATUS_SUCCESS: {
            let { chat_id, message_id, attachment_id, is_rejected, is_approved, user } = action.payload;


            if (!message_id && attachment_id) {
                message_id = state.chatMessages[chat_id].find((message) => {
                    return message.media.find((m) => m.id === attachment_id)
                })?.id;
            }

            const updatedChatMessages = state.chatMessages[chat_id].map((message) => {
                if (message.id !== message_id) return message;

                return {
                    ...message,
                    media: message.media.map((mediaItem) => {
                        if (mediaItem.id !== attachment_id) return mediaItem;

                        return {
                            ...mediaItem,
                            is_rejected,
                            is_approved,
                            ...(is_rejected ? { rejector: user } : {}),
                            ...(is_approved ? { approver: user } : {}),
                        };
                    }),
                };
            });

            const updatedChatMedia = Object.fromEntries(
                Object.entries(state.chatMedia).map(([key, mediaList]) => {
                    if (!key.startsWith(`${chat_id}-`)) return [key, mediaList];

                    const updatedMediaList = mediaList.some((a) => a.id === attachment_id)
                        ? mediaList.map((attachment) => {
                            if (attachment.id !== attachment_id) return attachment;

                            return {
                                ...attachment,
                                is_rejected,
                                is_approved,
                                ...(is_rejected ? { rejector: user } : {}),
                                ...(is_approved ? { approver: user } : {}),
                            };
                        })
                        : mediaList;

                    return [key, updatedMediaList];
                })
            );

            return {
                ...state,
                chatMessages: {
                    ...state.chatMessages,
                    [chat_id]: updatedChatMessages,
                },
                chatMedia: { ...updatedChatMedia },
            };
        }

        case chat.GET_USERS_FOR_MENTIONS_SUCCESS: {
            const data = action.payload || [];
            return {
                ...state,
                usersForMentions: data.map((user) => ({ id: user.id, display: user.full_name, ...user }))
            }
        }



        default:
            return state;
    }
};

export default chatReducer;
